;(function() {
  'use strict'

  service.$inject = ["surveyFactory"];
  angular.module('core.services').factory('elementFactory', service)

  // --------------------

  /* @ngInject */
  function service(surveyFactory) {
    // var surveyListImage = './img/survey-icon.png';
    var featureImages = {
      place: './img/ele-bg-place.png',
      product: './img/ele-bg-product.png',
      other: './img/ele-bg-other.png',
      code: './img/ele-bg-other.png',
    }

    return {
      transform: transform,
    }

    function transform(data, isElementSource) {
      if (!_.isArray(data)) {
        data = [data]
      }
      _.each(data, function(element) {
        element.extras = {}
        element.extras.isElementSource = isElementSource
        getTitle(element)
        getSubtext(element)
        getLogoStyles(element)
        getFeatureStyles(element)
        getQuickSurvey(element)
        getSurveys(element)
      })
    }

    function getTitle(element) {
      element.extras.title = element.name || element.title
    }

    function getSubtext(element) {
      if (element.type === 'product') {
        element.extras.subtext = element.brand
      } else if (
        element.type === 'place' &&
        element.isSubscriberOwned &&
        element.subTitle
      ) {
        element.extras.subtext = element.subTitle
      } else if (element.type === 'place') {
        var location = element.location || element.placeData || element
        if (!location) {
          element.extras.subtext = ''
          return
        }
        var address = location.address ? location.address + ', ' : ''
        var city = location.city ? location.city + ', ' : ''
        var state = location.state || ''
        element.extras.subtext = address + city + state
      } else if (element.type === 'other') {
        element.extras.subtext = element.subTitle
      }
    }

    function getLogoStyles(element) {
      var styles = {}
      styles['background-image'] = 'url(' + element.imageUrl + ')'
      if (
        _.includes(element.imageUrl, '/img/categories') ||
        _.includes(element.imageUrl, '.white.orange.svg')
      ) {
        styles['background-size'] = '70%'
      } else {
        styles['background-color'] = 'transparent'
      }
      element.extras.logoStyles = styles
    }

    function getFeatureStyles(element) {
      var styles = {}
      // glow app default
      if (
        !element.featureImageUrl &&
        element.id === '027c9c7f-c5a7-4b8e-935d-48778838c88a'
      ) {
        element.featureImageUrl =
          'http://static.glowfeed.com/img/element-logos/glow-app-element-feature.png'
      }
      element.featureImageUrl =
        element.featureImageUrl || featureImages[element.type]
      styles['background-image'] = 'url(' + element.featureImageUrl + ')'
      element.extras.featureStyles = styles
    }

    function getQuickSurvey(element) {
      var survey = _.find(element.surveys, { type: 'quick', state: 'LIVE' })
      if (survey) {
        element.extras.quickSurvey = survey.id
        element.extras.quickSurveyQuestion = survey.questions[0].title
      }
    }

    function getSurveys(element) {
      if (element.isPrivate) {
        element.extras.surveys = []
        return
      }
      var surveys = _.filter(element.surveys, { state: 'LIVE' })
      element.extras.surveys = _.reject(surveys, { type: 'quick' })
      surveyFactory.transform(element.extras.surveys)
    }
  }
})()
